<template>
  <div class="bg-white p-12 text-black font-simhei leading-relaxed toc-page-container">
    <!-- Header -->
    <h1 class="text-3xl text-center mt-16 mb-24 tracking-[1em] font-normal">目录</h1>

    <!-- Content List -->
    <div class="max-w-xl mx-auto space-y-1 text-base">
      
      <!-- Abstract -->
      <div class="toc-row">
        <span>摘 要</span>
        <span class="dots"></span>
        <span>I</span>
      </div>

      <template v-if="catalogs && catalogs.length > 0">
        <div v-for="(item, index) in flattenedCatalogs" :key="index" 
             :class="['toc-row', getIndentClass(item.level), index > 0 && item.level === 1 ? 'mt-4' : '']">
          <span>{{ item.label }}</span>
          <span class="dots"></span>
          <span>{{ item.page || '' }}</span>
        </div>
      </template>

      <template v-else>
        <!-- Chapter 1 -->
        <div class="toc-row mt-4">
          <span>一、绪论</span>
          <span class="dots"></span>
          <span>1</span>
        </div>
        <div class="toc-row pl-8">
          <span>(一) 研究背景：基层治理与老年服务中老年教育的重要性凸显</span>
          <span class="dots"></span>
          <span>1</span>
        </div>
        <!-- ... (keep other hardcoded items if needed for fallback, or just clear them if we expect props) ... -->
        <!-- Shortened fallback for brevity, assuming props will be used mostly -->
         <div class="toc-row pl-8">
          <span>(二) 研究意义：提升基层治理服务质量与促进老年教育发展</span>
          <span class="dots"></span>
          <span>1</span>
        </div>
      </template>

    </div>
    
    <!-- Footer Page Number -->
    <div class="text-center mt-12">
      <span>i</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';

const props = defineProps({
  catalogs: {
    type: Array,
    default: () => []
  }
});

const getIndentClass = (level: number) => {
  if (level === 2) return 'pl-8';
  if (level === 3) return 'pl-16';
  return '';
};

const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

const flattenedCatalogs = computed(() => {
  const result: any[] = [];
  if (!props.catalogs) return result;

  props.catalogs.forEach((item: any, index: number) => {
    // Level 1
    const level1Title = `${chineseNumbers[index] || (index + 1)}、${item.title || item.label}`;
    result.push({ label: level1Title, level: 1, page:  Math.floor(Math.random() * 5) + 1 + index * 3 }); // Mock page numbers

    if (item.children) {
      item.children.forEach((child: any, childIndex: number) => {
        // Level 2
        const level2Title = `(${chineseNumbers[childIndex] || (childIndex + 1)}) ${child.title || child.label}`;
        result.push({ label: level2Title, level: 2, page: result[result.length - 1].page });

        if (child.children) {
            child.children.forEach((subChild: any, subIndex: number) => {
                 // Level 3 (Optional, maybe not shown in TOC or shown with deeper indent)
                 const level3Title = `${subIndex + 1}. ${subChild.title || subChild.label}`;
                  result.push({ label: level3Title, level: 3, page: result[result.length - 1].page });
            });
        }
      });
    }
  });
  return result;
});
</script>

<style scoped>
.font-simhei {
  font-family: SimHei, "Microsoft YaHei", sans-serif;
}

.toc-row {
  display: flex;
  align-items: baseline;
  width: 100%;
}

.dots {
  flex: 1;
  border-bottom: 1px dotted black;
  margin: 0 4px;
}

.toc-page-container {
  min-height: 100vh;
}
</style>